<template>
  <div class="text-center">
    <v-card class="text-center" elevation="0">
      <v-tabs
        v-model="tab"
        background-color="#1976d242"
        dark
        height="90"
        icons-and-text
      >
        <v-tab
          v-for="item in getProductToDisplay"
          :key="item"
          active-class="primary"
        >
          <!--                        {{ item.tab #1976d242                             style="color:#1976d2;"}}-->
          <span style="font-size: 10px">
            {{ item.serviceCategoryName }}
          </span>
          <v-icon class="m-padd-5" size="30">
            {{ item.icon }}
          </v-icon>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(item) in getProductToDisplay" :key="item">
          <v-row class="text-center mx-auto m-center">
            <v-col
              v-for="entity in item.servicesCategorsEntits"
              :key="entity"
              class="mt-5 text-justify mt-n4 mb-n2"
              cols="12"
              xs="12"
              sm="12"
              md="6"
              lg="4"
            >
              <v-card
                class="ma-2"
                style="box-shadow: 0 4px 1px -3px #0000000d, 0 0 0 0 #00000000, 0 1px 5px 0 #00000008; background-color: #f6f6f6"
              >
                <v-card-text class="blue-grey--text">
                  <span>
                    <v-avatar size="40">
                      <v-icon color="blue-grey">mdi-format-list-checks</v-icon>
                    </v-avatar>
                    <span
                      class="ml-3"
                      style="font-size: 12px; text-transform: uppercase"
                    >
                      {{ entity.entity.entityName }}
                    </span>
                    <span style="position: absolute; right: 4px; top: 25%;">
                      <v-menu left bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon v-on="on" v-bind="attrs">
                            <v-icon color="blue-grey">mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>

                        <v-list>
                          <span
                            v-for="product in entity.entity
                              .productCategoryEntits"
                            :key="product"
                          >
                            <v-list-item
                              @click="
                                openWindowListCategory(
                                  entity.entity.entityName,
                                  entity.entity.entityUUID,
                                  product.productsCategory.productCategoryUUID
                                )
                              "
                            >
                              <v-list-item-title>{{
                                product.productsCategory.productCategoryName
                              }}</v-list-item-title>
                            </v-list-item>
                          </span>
                        </v-list>
                      </v-menu>
                    </span>
                  </span>
                </v-card-text>
              </v-card>
              <!--              </div>-->
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <open-window-payment></open-window-payment>
    <list-c-product-category></list-c-product-category>
  </div>
</template>

<script>
import OpenWindowPayment from "../../../tools/OpenWindowPayment";
import { mapHelper } from "@/store/helper";
import ListCProductCategory from "./ListCProductCategory";
export default {
  name: "Entidades",
  components: { ListCProductCategory, OpenWindowPayment },
  data: () => ({
    tab: null
  }),
  methods: {
    openWindowListCategory(Entity, EntityUUID,  productCategoryUUID) {
      let payloadEntity = {
        open: true,
        entity: Entity,
        entityUuid: EntityUUID,
        productCategoryUUID: productCategoryUUID
      };
      this.$store.dispatch(
        "displayAllProductCategory",
        payloadEntity
      );
    }
  },

  computed: {
    ...mapHelper
  }
};
</script>
<style scoped></style>
